import HttpMethod from '@/consts/httpMethod';
import { processRequest, processErrorResponse, processSuccessResponse } from '@/helpers';

export default {
  async getGroups() {
    const ep = {
      baseURL: process.env.VUE_APP_ADMIN_API_ROOT,
      url: '/v1/groups',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: { pageSize: 1000 } });
      const data = processSuccessResponse(res);
      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createUser(data) {
    const ep = {
      baseURL: process.env.VUE_APP_ADMIN_API_ROOT,
      url: '/v1/users',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const dish = processSuccessResponse(res);
      return dish;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateUser(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_ADMIN_API_ROOT,
      url: `/v1/users/${id}`,
      method: HttpMethod.PUT
    };

    try {
      const res = await processRequest(ep, { data });
      const dish = processSuccessResponse(res);
      return dish;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getUser(id) {
    const ep = {
      baseURL: process.env.VUE_APP_ADMIN_API_ROOT,
      url: `/v1/users/${id}`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const dish = processSuccessResponse(res);
      return dish;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
